import React from 'react';
import { formatGap, gapDirection, gapWords } from '../format';

/**
 * A signed guide gap. Direction is carried three ways (shape, sign and
 * words for screen readers) so it never depends on colour alone. The number
 * stays in text ink; only the small mark wears the data colour.
 */
export function GapMark({ direction, className = '' }) {
  if (direction === 'above') {
    return (
      <svg className={`re-gapmark re-gapmark--above ${className}`} viewBox="0 0 10 10" aria-hidden="true" focusable="false">
        <path d="M1 8.5 L5 1.5 L9 8.5 Z" />
      </svg>
    );
  }
  if (direction === 'below') {
    return (
      <svg className={`re-gapmark re-gapmark--below ${className}`} viewBox="0 0 10 10" aria-hidden="true" focusable="false">
        <path d="M1 1.5 L5 8.5 L9 1.5 Z" />
      </svg>
    );
  }
  return (
    <svg className={`re-gapmark re-gapmark--at ${className}`} viewBox="0 0 10 10" aria-hidden="true" focusable="false">
      <rect x="1" y="4" width="8" height="2" rx="1" />
    </svg>
  );
}

export default function GapChip({ value, withWords = false, className = '' }) {
  const direction = gapDirection(value);
  if (direction === 'none') {
    return <span className={`re-gap re-gap--none ${className}`.trim()}>{'—'}</span>;
  }
  return (
    <span className={`re-gap re-gap--${direction} ${className}`.trim()}>
      <GapMark direction={direction} />
      <span className="re-gap__value">{formatGap(value)}</span>
      {withWords ? (
        <span className="re-gap__words">{gapWords(value)}</span>
      ) : (
        <span className="re-sr-only"> {gapWords(value)}</span>
      )}
    </span>
  );
}
